import script from "./diamondsSearchFormTextList.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearchFormTextList.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearchFormTextList.vue?vue&type=style&index=0&id=a60ae7a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a60ae7a6"]])

export default __exports__